// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5cd73c0f","667":"f93f17e9","977":"8f585f6f"}[chunkId] + ".chunk.js";
};